import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { ko } from '@/i18n/ko';

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error || !data.user) {
      setErr(error?.message ?? '로그인에 실패했습니다');
      return;
    }
    const { data: profile } = await supabase
      .from('profiles')
      .select('role')
      .eq('id', data.user.id)
      .maybeSingle();
    // 역할 기준 라우팅. 직전에 보고 있던 path는 그 역할이 접근 가능한지 보장할 수 없어 무시.
    navigate(profile?.role === 'admin' ? '/admin' : '/me', { replace: true });
  }

  return (
    <div className="card space-y-5">
      <h1 className="text-2xl font-bold">{ko.auth.login}</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="label" htmlFor="email">{ko.auth.email}</label>
          <input
            id="email"
            className="field"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="label" htmlFor="password">{ko.auth.password}</label>
          <input
            id="password"
            className="field"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {err && <p className="text-danger text-base">{err}</p>}
        <button type="submit" className="btn-primary w-full" disabled={busy}>
          {busy ? ko.common.loading : ko.auth.login}
        </button>
      </form>
      <div className="text-center text-base text-ink-muted">
        무당이신가요?{' '}
        <Link className="text-brand font-semibold" to="/signup">
          {ko.auth.signup}
        </Link>
      </div>
    </div>
  );
}
